<template>
  <div class="bigscreen-sales">
    <div class="bigscreen-sales__header">
      <!-- 头部 -->
      <SalesHeader />
    </div>
    <div class="bigscreen-sales__body">
      <!-- 统计部分 -->
      <!-- <Statistics /> -->
      <!-- 下半部分 左 中 右结构 -->
      <div class="vocational">
        <!-- 业务结单统计 -->
        <!-- <div class="vocational-left">
          <ShippingShipPartsall class="con-box bottom" />
        </div> -->
        <div class="vocational-center m-l-16">
          <!-- 近13个月业务数量统计 -->
          <!-- <Quantity class="con-box top" /> -->
          <!-- 今日出货计划表 -->
          <ShippingShipPartsall class="con-box bottom" />
         
        </div>
        <!-- <div class="vocational-right m-l-16"> -->
          <!-- 部门未完成工时统计 -->
          <!-- <ManHour class="con-box top" /> -->
          <!-- 品质异常统计 -->
          <!-- <Unusual class="con-box bottom" /> -->
        <!-- </div> -->
      </div>
    </div>
    <div class="bigscreen-sales__bottom" >
    </div>
  </div>
</template>

<script>
import SalesHeader from './components/SalesHeader.vue'
// import Statistics from './components/Statistics.vue'
// import ReceivingOrders from './components/ReceivingOrders.vue'
// import Quantity from './components/Quantity.vue'
// import ShippingSchedule from './components/ShippingSchedule.vue'
import ShippingShipPartsall from './components/ShippingShipPartsall.vue'
// import ShippingPO from './components/ShippingPO.vue'
// import ManHour from './components/ManHour.vue'
// import Unusual from './components/Unusual.vue'
export default {
  name: 'index',
  data () {
    return {
      isFullscreen:false
    }
  },
  components: {
    SalesHeader,
    // Statistics,
    // ReceivingOrders,
    // Quantity,
    // ShippingSchedule,
    // ShippingPO,
    ShippingShipPartsall,

    // ManHour,
    // Unusual
  },
  watch: {},
  mounted () {
    document.documentElement.webkitRequestFullScreen()
    this.checkFull();
    window.addEventListener('dblclick',this.handleFullScreen);
    window.addEventListener('keyup',this.handleKeyup);
    const that = this
    window.onresize = () => {
        return (() => {
          that.checkFull();
        })()
    }
  },
  methods: {
    // 判断全屏
    checkFull() {
      let winFlag = window.innerHeight === window.screen.height
      let isFull = window.fullScreen || document.webkitIsFullScreen

      if (isFull === undefined) {
        this.isFullscreen = winFlag
      } else {
        this.isFullscreen = winFlag || isFull
      }
    },
    handleFullScreen(){
      let element = document.documentElement;
      if(this.isFullscreen)
      {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        this.isFullscreen = false;
      }else{
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
        }
         this.isFullscreen = true;
      }
    },
    handleKeyup(event){
      const e = event || window.event || arguments.callee.caller.arguments[0]
      if(!e)
      {
        return;
      }
      if(e.keyCode == 66 || e.keyCode == 13)
      {
        this.handleFullScreen();
      }
    },
    screenwake(){

      //getWindow().setFlags(WindowManager.LayoutParams.FLAG_KEEP_SCREEN_ON, WindowManager.LayoutParams.FLAG_KEEP_SCREEN_ON); 
        //   navigator.wakeLock.request('screen').then(function(wakeLock) {
        // console.log('唤醒锁已获取');
        // 在这里进行你想做的事情
        // ...
        // 然后在完成后释放唤醒锁
        // wakeLock.release();
        // console.log('唤醒锁已释放');
      // });
    }
  },
  created () {
    // this.screenwake();
  },
}
// background-image: url('../../assets/images/bigscreenSales/bottom.png');      
</script>

<style scoped lang="less">
  .bigscreen-sales {
    width: 100%;
    height: 100vh;
    padding-top: 4px;
    box-sizing: border-box;
    background: #010916;
    display: flex;
    flex-direction: column;

    &__header {
      width: 100%;
      height: 74px;
      background: linear-gradient(270deg,
          #060c16 0%,
          rgba(9, 28, 45, 0.9) 50.06%,
          #11182d 101.04%);
    }

    &__body {
      margin-top: 4px;
      flex: 1;
      min-height: 0;
      padding: 0 24px;
      display: flex;
      flex-direction: column;

      .vocational {
        flex: 1;
        min-height: 0;
        margin-top: 10px;
        display: flex;
        height: 100%;

        .con-box {
          background: rgba(10, 36, 62, 0.6);
          border-radius: 8px;
          padding: 16px;
          box-sizing: border-box;
        }

        .vocational-left {
          width: 500px;
          height: 100%;
        }

        .vocational-center,
        .vocational-right {
          display: flex;
          flex-direction: column;
          height: 100%;

          .top {
            flex: 1;
            margin-bottom: 16px;
          }

          .bottom {
            min-height: 0;
            height: 100%;
          }
        }

        .vocational-center {
          
          width: 1820px;
        }

        .vocational-right {
          width: 424px;
        }
      }
    }

    &__bottom {
      width: 100%;
      height: 60px;
       background-image: url('http://47.107.138.238/img/bottom.aaf8d41.png');      
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/shipparts.vue